import { create } from "@/api/EtiquetaDePreco";
import { FormEtiquetaDePreco } from "@/models/EtiquetaDePreco";
import { EtiquetaDePrecoServiceAdapter } from "@/usecases";
import { injectable } from "inversify-props";

@injectable()
export class EtiquetaDePrecoService implements EtiquetaDePrecoServiceAdapter {
	create = async (etiqueta: FormEtiquetaDePreco ) => await create (etiqueta)
}